var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('base-app-bar',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('v-main',{staticClass:"main-content bg-body"},[_c('navigation-drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('base-view')],1),_c('footer-view'),_c('renew-token')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }